import { UrlConstants } from "../url.constants";
export class ApiSolvemDocumentSigningConstants {
    static URL = UrlConstants.API_V2 + "SolvemDocumentSigning";
    static FUNCTION_GET_DOCUMENT_SIGNING_URL = "GetDocumentSigningUrl";
}
